import { Validators } from '@angular/forms';

export const ALLOWED_PARENT_ORIGINS = ['https://maif.popvalet.com', 'https://matmut.popvalet.com'];

export const EMAIL_VALIDATOR_PATTERN =
  Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

export const WGARAGE_VALIDATOR_PATTERN =
  Validators.pattern(/^W-\d{3}-[A-Z]{2}$/);

export const ACCEPTED_VALET_FILE_TYPES = '.pdf,.jpg, .jpeg, .png, .gif, .tif, .tiff';
export const ACCEPTED_ANOMALY_FILE_TYPES = '.pdf, .jpg, .jpeg, .png';
export const ACCEPTED_PROFILE_PICTURE_FILE_TYPES = '.jpg, .jpeg, .png';
export const WEEKDAYS= ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'] as const;
export type Weekday = (typeof WEEKDAYS)[number];
